import { Outlet } from 'react-router-dom';

import { AuthProvider } from '@/auth/auth-provider';
import { AnalyticsTracker } from '@/lib/analytics/analytics-tracker';

/**
 * The router's root element.
 *
 * `AuthProvider` is here rather than in `providers.tsx` because it needs the
 * router (it navigates on session expiry) and `RouterProvider` cannot be nested
 * inside its own descendants.
 *
 * `AnalyticsTracker` sits inside it for the same reason and one more:
 * `AuthProvider` renders its children only once the session has resolved and
 * the impersonation handoff has been read, so the tracker never loads before
 * it knows whether a super-admin is impersonating the clinic.
 */
export function Root() {
  return (
    <AuthProvider>
      <AnalyticsTracker />
      <Outlet />
    </AuthProvider>
  );
}
